export default __webpack_public_path__ + "static/B0223-1d05343484394b94450834671be364a9.png";